import {
  Button,
  Container,
  IconButton,
  LinearProgress,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { Box } from "@mui/system";
import React, { useCallback, useEffect, useState } from "react";
import InformasiKejadian from "./Component/InformasiKejadian";
import KemungkinanPenyebab from "./Component/KemungkinanPenyebab";
import HeaderUser from "./Component/HeaderUser";
import { useNavigate } from "react-router-dom";
import FooterReport from "./Component/FooterReport";
import ApiService from "../../services/ApiService";
import {
  getDateTimeNow,
  momentDateToDB,
  momentTimeToDB,
} from "../../utils/dateTime";
import { LoadingButton } from "@mui/lab";
import DialogCustom from "../../components/DialogCustom";
import SnackbarCustom from "../../components/SnackbarCustom";
import EstimateImpactRevamp from "./Component/EstimateImpactRevamp";
import { debounce } from "lodash";
import ListReviewer from "./Component/ListReviewer";
import { ConnectingAirportsOutlined } from "@mui/icons-material";
import InformasiTembusan from "./Component/InformasiTembusan";

const potensiTingkatKeparahanItem = [
  { value: "1", name: "Insignificant" },
  { value: "2", name: "Minor" },
  { value: "3", name: "Moderate" },
  { value: "4", name: "Significant" },
  { value: "5", name: "Catastrophic" },
];

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

const CreateLKP = () => {
  const navigate = useNavigate();

  const [showRecordable, setShowRecordable] = useState(0);
  const [inputFields, setInputFields] = useState({
    //// Header User
    idLkp: 0,
    noLkp: "",
    idUnitBisnis: null,
    idRegional: null,
    idLokasi: null,
    namaLokasi: "",
    tglKejadian: "",
    waktuKejadian: "",
    tglLaporan: getDateTimeNow(),
    judulLaporan: "",
    statusLkp: "",
    perusahaanTerlibat: "",
    documentPosition: "",
    listApproval: [],

    //// Informasi Kejadian
    deskripsiSingkat: "",
    locationTagLong: 0,
    locationTagLat: 0,
    namaLokasiOnMap: "",
    isHipo: true,
    listAllKategoriInsiden: [
      {
        idDetailLkpKategoriInsiden: 0,
        kategoriInsidenId: 0,
        kategoriInsidenName: "",
        kategoriInsidenCode: "",
        detailKategoriInsidenId: 0,
        detailKategoriInsidenName: "",
        idKategoriHipo: 0,
        isCheked: true,
      },
    ],
    isReportAble: false,
    isWorkRelated: false,
    isRecordAble: false,

    //// Estimate Impact
    listDetailEstimateImpact: [
      {
        detailEstimateImpactId: 0,
        kode: "",
        nama: "",
        isByValue: true,
      },
    ],
    listDetailEstimateContent: [
      {
        idTblDataLkpEstimateImpact: 0,
        detailEstimateImpactId: 0,
        detailContentEstimateImpactId: 0,
        detailContentEstimateImpactName: "",
        estimateImpactContentItemId: 0,
        estimateImpactContentItemName: "",
        detailContentValueEstimateImpactId: 0,
        idTipePekerja: 0,
        tipePekerja: "",
        jumlahOrNilaiKerugian: 0,
        satuan: "",
        konversiSatuan: 0,
        nilaiKonversi: 0,
        tingkatKeparahan: 0,
        keterangan: "",
        isByValue: true,
      },
    ],
    potensiTingkatKeparahan: "",
    probabilitasKejadian: 0,

    //// Kemungkinan Penyebab
    kemungkinanPenyebabLangsung: "",
    kemungkinanPenyebabDasar: "",
    immadiateAction: "",
    uploadDocumentList: [],
    pembuatDokumen: null,
    createdBy: null,
    modifiedBy: null,
    saveAs: "", // draft, submit
    staticValueBTR: 93000000,
    listKepadas: [],
    listTembusan: [],
  });
  const [dataUnit, setDataUnit] = useState([]);
  const [dataRegion, setDataRegion] = useState([]);
  const [dataLokasi, setDataLokasi] = useState([]);
  const [dataIdamanUser, setDataIdamanUser] = useState([]);

  // Fetch Form LKP Initial Value
  const [initialValue, setInitialValue] = useState(null);
  const [loading, setLoading] = useState({
    fetch: false,
    submit: false,
    upload: false,
    searchIdamanUsers: false,
  });
  const [errorModal, setErrorModal] = useState({
    isOpen: false,
    message: "",
    validationErrMessage: [],
    listApprovalValidation: false,
  });
  useEffect(() => {
    const fetchInit = async () => {
      try {
        setLoading((prev) => ({ ...prev, fetch: true }));
        const resInit = await Promise.all([
          ApiService.getIncimanLkp("MA=="),
          ApiService.getMsTipePekerjaan().then((res) => res.data.payload),
          ApiService.getMsUnit().then((res) => res.data.payload),
          ApiService.getMsRegional().then((res) => res.data.payload),
        ]);
        // console.log("payload lkp", resInit[0]);
        if (!resInit[0].data.isOk) throw resInit[0].data.message;
        setInitialValue({ ...resInit[0].data.payload, uploadDocumentList: [] });
        setInputFields((prev) => ({
          ...prev,
          ...resInit[0].data.payload,
          estimateImpactSelected: {
            title: new Array(6),
            type: new Array(2),
          },
          tglKejadian: null,
          tglLaporan: new Date(),
          listTipePekerjaan: resInit[1],
          listApproval: resInit[0].data.payload.listApproval || [],
        }));
        setDataUnit(resInit[2]);
        setDataRegion(resInit[3]);
        setLoading((prev) => ({ ...prev, fetch: false }));
      } catch (error) {
        setLoading((prev) => ({ ...prev, fetch: false }));
        setErrorModal({ isOpen: true, message: error });
        // openSnack(error);
      }
    };

    fetchInit();
  }, []);

  useEffect(() => {
    if (!inputFields.idRegional) return;
    fetchDataLokasi(inputFields.idRegional);
  }, [inputFields.idRegional]);

  const [resSave, setResSave] = useState(null);

  const [open, setOpen] = useState(false);
  const [saveType, setSaveType] = useState("draft");
  const handleOpen = (type) => {
    setSaveType(type);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSaveType("draft");
  };

  const handleSaveDraft = (type) => {
    setLoadDraft(true);
    setSaveType(type);
    handleSaveAs();
  };

  const handleSaveAs = async () => {
    //// TEST FINAL VALUE BEFORE POST
    // setLoadSave(true);
    // let finalValue = {
    //   ...inputFields,
    //   tglKejadian:
    //     momentDateToDB(inputFields.tglKejadian) +
    //     "T" +
    //     momentTimeToDB(inputFields.waktuKejadian),
    //   waktuKejadian:
    //     momentDateToDB(inputFields.tglKejadian) +
    //     "T" +
    //     momentTimeToDB(inputFields.waktuKejadian),
    //   listAllKategoriInsiden: selectedKategoriInsiden,
    //   listDetailEstimateContent: usedDetailEstimateContent,
    //   saveAs: saveType,
    //   listDetailEstimateImpact: initialValue.listDetailEstimateImpact,
    //   isHipo: inputFields.isHipo === "true",
    // };
    // setLoadSave(false);
    // return;

    // // SIngle file upload
    setLoadSave(true);

    try {
      const { listTipePekerjaan, estimateImpactSelected, ...payload } =
        inputFields;
      let finalValue = {
        ...payload,
        tglKejadian:
          momentDateToDB(inputFields.tglKejadian) +
            "T" +
            momentTimeToDB(inputFields.waktuKejadian) || null,
        waktuKejadian:
          momentDateToDB(inputFields.tglKejadian) +
            "T" +
            momentTimeToDB(inputFields.waktuKejadian) || null,
        listAllKategoriInsiden: selectedKategoriInsiden,
        isHipo:
          inputFields.isHipo === "true" || inputFields.isHipo === true
            ? true
            : false,
        saveAs: saveType,
        listDetailEstimateImpactContentItem: [],
        listDetailEstimateImpact: [],
        estimateImpactSelected: null,
        listTipePekerjaan: null,
      };

      console.log("finalValue", finalValue);
      let { listApproval } = inputFields;
      if (saveType === "submit" || saveType === "draft") {
        if (
          !inputFields.listApproval ||
          inputFields.listApproval?.length === 0
        ) {
          // console.log("request list approval to api");
          // console.log("List_Approval>>>", inputFields.listApproval);
          const resValidate = await ApiService.validateLkp({
            regionId: finalValue.idRegional,
            documentPosition: finalValue.documentPosition,
          });
          listApproval = resValidate.data?.payload?.listApproval || [];
          setInputFields((prev) => ({ ...prev, listApproval }));
          //console.log("res>>>", resValidate);
          if (!resValidate.data.payload?.isCompleted) {
            // throw resValidate.data;
            setOpen(false);
            setSnackMessage("Lengkapi data reviewer");
            setSnackOpen(true);
            setLoadSave(false);
            setErrorModal((prev) => ({
              ...prev,
              listApprovalValidation: true,
            }));
            //disabled button Save As Draft
            setSaveType("draft");
            return;
          }
        } else {
          // VALIDASI LIST REVIEWER
          console.log("validasi list approval, make sure emailnya keisi semua");
          console.log("List_Approval>>>", inputFields.listApproval);
          let isValid = true;
          inputFields.listApproval.some((val) => {
            if (!val?.emailUser) {
              isValid = false;
              return true;
            }
            return false;
          });

          if (!isValid) {
            setSnackMessage("Lengkapi data reviewer");
            setOpen(false);
            setSnackOpen(true);
            setLoadSave(false);
            setSaveType("draft");
            return;
          }
        }
        setLoading((prev) => ({ ...prev, submit: false }));
      }

      const res = await ApiService.postIncimanLkp({
        ...finalValue,
        listApproval,
      });

      if (!res.data.isOk) {
        console.log("Data Req>>>", {
          ...finalValue,
          listApproval,
        });
        throw res.data;
      } else if (res.data.payload.noLkp) {
        setResSave(res.data.payload);
        setOpen(false);
        setOpen2(true);
      }
      setLoadDraft(false);
      setLoadSave(false);
    } catch (error) {
      console.log("Ini Errornya >>>", error);
      if (error.payload === undefined) {
        setErrorModal({
          validationErrMessage: [error.message],
          listApprovalValidation:
            inputFields.listApproval.length > 0 ? true : false,
        });
      } else {
        setErrorModal({
          validationErrMessage:
            error.payload === null
              ? [error.message]
              : error.payload.length > 0
              ? error.payload
              : [error.message],
          listApprovalValidation:
            inputFields.listApproval.length > 0 ? true : false,
        });
      }

      setOpen3(true);
      setOpen(false);
      setLoadDraft(false);
      setLoadSave(false);
    }
  };

  // listAllKategoriInsiden
  const [selectedKategoriInsiden, setSelectedKategoriInsiden] = useState([]);

  // listDetailEstimateContent
  const [usedDetailEstimateContent, setUsedDetailEstimateContent] = useState(
    []
  );

  const fetchTingkatKeparahanByValue = useCallback(
    debounce(
      async (
        { detailEstimateImpactId, value, totalFinancialImpactValue },
        callback
      ) => {
        const percentageBTR =
          inputFields.staticValueBTR == 0
            ? 0
            : Math.round(
                (totalFinancialImpactValue / inputFields.staticValueBTR) * 100
              );

        console.log("Total financial impact >>" + totalFinancialImpactValue);
        console.log("value >>" + inputFields.staticValueBTR);

        console.log(
          "percentageBTR >>" +
            (totalFinancialImpactValue / inputFields.staticValueBTR) * 100
        );

        const resSeverity = await Promise.all([
          ApiService.getTingkatKeparahanByValue({
            IdMstDetailEstimateImpact: detailEstimateImpactId,
            ContectValue: +value,
          }).then((res) => res.data.payload),
          ApiService.getTingkatKeparahanByValue({
            IdMstDetailEstimateImpact: 3, // Financial Impact
            ContectValue: percentageBTR,
          }).then((res) => res.data.payload),
        ]);

        callback(resSeverity);
      },
      300
    ),
    []
  );

  const fetchDataLokasi = async (id) => {
    const resLokasi = await ApiService.getMsLokasi(id).then(
      (res) => res.data.payload
    );
    setDataLokasi(resLokasi);
  };

  const checkPotensi = (list) => {
    let totalDeath = 0;
    let severity;
    list.forEach((dt) => {
      if (dt.kode === "DEAD") {
        totalDeath += Number(dt.jumlahOrNilaiKerugian);
      }
    });
    if (totalDeath > 1) {
      severity = 5;
    }
    // else if (totalDeath < 2) {
    //   severity = 4;
    // }
    else {
      severity = 4;
    }

    if (severity) {
      list = list.map((dt) => {
        if (dt.kode === "DEAD") {
          dt.tingkatKeparahan = severity;
        }
        return dt;
      });
    }

    if (!list) list = inputFields.listDetailEstimateContent;
    if (list.length < 1) {
      return {
        potensiTingkatKeparahan: null,
      };
    }
    const maxLevel = Math.max(...list.map((o) => o.tingkatKeparahan));
    if (maxLevel < 1 || maxLevel > 5) {
      return {
        potensiTingkatKeparahan: null,
      };
    }
    return {
      potensiTingkatKeparahan: potensiTingkatKeparahanItem.find(
        (o) => o.value == maxLevel
      ).name,
    };
  };

  const setIdamanUsers = useCallback(
    debounce(async (search) => {
      try {
        if (search?.trim() == "" || search?.trim().length < 5) return;
        setLoading((prev) => ({ ...prev, searchIdamanUsers: true }));

        const res = await ApiService.getIdamanUsers(search);
        if (!res.data.isOk) throw res.data;
        setDataIdamanUser(res.data.payload || []);
      } catch (error) {
        setSnackMessage(error.message);
        setSnackOpen(true);
      }
      setLoading((prev) => ({ ...prev, searchIdamanUsers: false }));
    }, 200)
  );

  // Dialog Save Berhasil
  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleDashboard = () => {
    navigate("/hsse/incident/dashboardlkp");
  };

  // Dialog Save Gagal
  const [open3, setOpen3] = useState(false);
  const handleClose3 = () => {
    setOpen3(false);
  };

  // Loading save
  const [loadSave, setLoadSave] = useState(false);
  const [loadDraft, setLoadDraft] = useState(false);

  // Snackbar
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const closeSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen(false);
  };
  const openSnack = (message) => {
    setSnackMessage(message);
    setSnackOpen(true);
  };

  if (loading.fetch) {
    return <p>Loading...</p>;
  }

  return (
    <div>
      <Container maxWidth={false}>
        <center>
          <h2>LAPORAN KEJADIAN PENTING</h2>
        </center>
        <Box component="form" noValidate autoComplete="off">
          <HeaderUser
            inputFields={inputFields}
            setInputFields={setInputFields}
            dataUnit={dataUnit}
            dataRegion={dataRegion}
            dataLokasi={dataLokasi}
          />
          <br></br>

          {initialValue !== null && (
            <InformasiKejadian
              selectedKategoriInsiden={selectedKategoriInsiden}
              setSelectedKategoriInsiden={setSelectedKategoriInsiden}
              setShowRecordable={setShowRecordable}
              inputFields={inputFields}
              setInputFields={setInputFields}
              listAllKategoriInsiden={initialValue.listAllKategoriInsiden}
            />
          )}

          <br></br>
          <EstimateImpactRevamp
            input={inputFields}
            setInput={setInputFields}
            setSnackbar={({ message }) => openSnack(message)}
            checkPotensi={checkPotensi}
            fetchTingkatKeparahan={fetchTingkatKeparahanByValue}
          />
          <br></br>

          <KemungkinanPenyebab
            inputFields={inputFields}
            setInputFields={setInputFields}
            setSnackbar={({ message }) => openSnack(message)}
          />
        </Box>
        <br />

        <InformasiTembusan
          loading={loading.searchIdamanUsers}
          input={inputFields}
          setInput={setInputFields}
          dataIdamanUser={dataIdamanUser}
          setIdamanUsers={setIdamanUsers}
          setDataIdamanUser={setDataIdamanUser}
          openSnack={openSnack}
        />

        {errorModal.listApprovalValidation ? (
          <ListReviewer
            loading={loading.searchIdamanUsers}
            input={inputFields}
            setInput={setInputFields}
            dataIdamanUser={dataIdamanUser}
            setIdamanUsers={setIdamanUsers}
            setDataIdamanUser={setDataIdamanUser}
          />
        ) : null}

        <FooterReport
          loadDraft={loadDraft}
          readOnly={loading.submit}
          handleSubmit={() => handleOpen("submit")}
          handleDraft={() => handleSaveDraft("draft")}
          createdDoc={inputFields.pembuatDokumen}
        />
      </Container>

      {/* Snackbar / Alert */}
      <SnackbarCustom
        duration={3000}
        type={"warning"}
        open={snackOpen}
        onClose={closeSnack}
        message={snackMessage}
      />

      {/* Dialog Konfirmasi Save */}
      <DialogCustom
        open={open}
        handleClose={handleClose}
        title={
          <>
            Notifikasi
            {handleClose ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </>
        }
        content={
          <>
            Apakah anda yakin akan {saveType.toUpperCase()} dokument ini? <br />
            Pastikan data sudah terisi dengan lengkap dan benar
          </>
        }
        actions={
          <>
            <Button
              onClick={handleClose}
              variant="outlined"
              disabled={loadSave}
            >
              Batal
            </Button>
            <LoadingButton
              onClick={handleSaveAs}
              autoFocus
              variant="contained"
              loading={loadSave}
              startIcon={<SaveIcon />}
              loadingPosition="start"
            >
              {!loadSave ? "Ya," : ""} Submit
            </LoadingButton>
          </>
        }
      />

      {/* Dialog Save Berhasil */}
      {resSave !== null && (
        <DialogCustom
          open={open2}
          handleClose={handleClose2}
          title={
            <>
              Notifikasi
              {handleClose2 ? (
                <IconButton
                  aria-label="close"
                  onClick={handleClose2}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              ) : null}
            </>
          }
          content={
            <>
              Berhasil Membuat LKP No {resSave.noLkp} <br />
              Dengan Status {resSave.statusLkp}
            </>
          }
          actions={
            <>
              <Button onClick={handleDashboard} autoFocus variant="contained">
                Kembali ke Dashboard
              </Button>
            </>
          }
        />
      )}

      {/* Dialog Save GAGAL */}
      <DialogCustom
        open={open3}
        handleClose={handleClose3}
        title={
          <>
            Notifikasi
            {handleClose3 ? (
              <IconButton
                aria-label="close"
                onClick={handleClose3}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </>
        }
        content={
          errorModal.validationErrMessage ? (
            <>
              {errorModal.validationErrMessage.map((item, idx) => (
                <p key={idx} style={{ margin: 0, padding: 0 }}>
                  {item}
                </p>
              ))}
            </>
          ) : (
            <>
              LKP Gagal Dibuat! <br />
              Silahkan periksa kembali data yang telah didinputkan.
            </>
          )
        }
        actions={
          <>
            <Button onClick={handleClose3} autoFocus variant="contained">
              Tutup
            </Button>
          </>
        }
      />
      <DialogCustom
        open={errorModal.isOpen}
        handleClose={() =>
          setErrorModal((prev) => ({ ...prev, isOpen: false }))
        }
        title={
          <>
            Terjadi Kesalahan
            <IconButton
              aria-label="close"
              onClick={() =>
                setErrorModal((prev) => ({ ...prev, isOpen: false }))
              }
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </>
        }
        content={<p style={{ minWidth: 200 }}>{errorModal.message}</p>}
        actions={
          <>
            <Button
              onClick={() => navigate("/hsse/incident/dashboardlkp")}
              autoFocus
              variant="contained"
            >
              Kembali
            </Button>
          </>
        }
      />
    </div>
  );
};

export default CreateLKP;
